import { useCallback } from 'react';
import { retainTaskCampaignFilters } from '../../../../../models/Task/campaignFilters';
import { OutgoingCallsRequest } from '../../../../../store/reducers/OutgoingCallsSlice';
import { ReportRequest } from '../../../../../store/reducers/ReportSlice';

interface Props {
  onCallRequest: (value: OutgoingCallsRequest) => void;
  callRequest: OutgoingCallsRequest;
  onCallRequestReport: (value: ReportRequest) => void;
  callRequestReport: ReportRequest;
}

export const useOutgoingFilterChanges = ({
  onCallRequest,
  callRequest,
  onCallRequestReport,
  callRequestReport,
}: Props) => {
  const handleResult = useCallback(
    (e: string[]) => {
      onCallRequest({
        ...callRequest,
        'Filter.Result': e,
      });

      onCallRequestReport({
        ...callRequestReport,
        Results: e,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleClinics = useCallback(
    (e: string[]) => {
      onCallRequest({
        ...callRequest,
        'Filter.ClinicIds': e,
      });

      onCallRequestReport({
        ...callRequestReport,
        ClinicIds: e,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleSpecialization = useCallback(
    (e: string[]) => {
      onCallRequest({
        ...callRequest,
        'Filter.SpecializationIds': e,
      });
      onCallRequestReport({
        ...callRequestReport,
        SpecializationIds: e,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleDoctors = useCallback(
    (e: string[]) => {
      onCallRequest({
        ...callRequest,
        'Filter.DoctorIds': e,
      });
      onCallRequestReport({
        ...callRequestReport,
        DoctorIds: e,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleNotificationType = useCallback(
    (e: string[]) => {
      const campaigns = retainTaskCampaignFilters(e, {
        FormTemplateIds: callRequest['Filter.FormTemplateIds'],
        FormBatchIds: callRequest['Filter.FormBatchIds'],
        DispensarizationBatchIds:
          callRequest['Filter.DispensarizationBatchIds'],
      });
      onCallRequest({
        ...callRequest,
        PageIndex: 0,
        'Filter.FormTemplateIds': campaigns.FormTemplateIds,
        'Filter.FormBatchIds': campaigns.FormBatchIds,
        'Filter.DispensarizationBatchIds': campaigns.DispensarizationBatchIds,
        'Filter.NotificationTypes': e,
        'Filter.Types': e,
      });
      onCallRequestReport({
        ...callRequestReport,
        NotificationTypes: e,
        Types: e,
        ...campaigns,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleTaskStatus = useCallback(
    (e: string[]) => {
      onCallRequest({
        ...callRequest,
        'Filter.States': e,
      });

      onCallRequestReport({
        ...callRequestReport,
        States: e,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleAttemptStatus = useCallback(
    (e: string[]) => {
      onCallRequest({
        ...callRequest,
        'Filter.AttemptStates': e,
      });

      onCallRequestReport({
        ...callRequestReport,
        AttemptStates: e,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleAttemptTimeRange = useCallback(
    (attemptFrom?: string, attemptTo?: string) => {
      onCallRequest({
        ...callRequest,
        PageIndex: 0,
        'Filter.AttemptFrom': attemptFrom,
        'Filter.AttemptTo': attemptTo,
      });

      onCallRequestReport({
        ...callRequestReport,
        AttemptFrom: attemptFrom,
        AttemptTo: attemptTo,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  return {
    handleResult,
    handleClinics,
    handleSpecialization,
    handleDoctors,
    handleNotificationType,
    handleTaskStatus,
    handleAttemptStatus,
    handleAttemptTimeRange,
  };
};
